/* eslint-disable import/prefer-default-export */
import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import { getInvoiceDraft } from "api/services/invoice";
import { invoiceQueryKeys } from "./invoiceQueryKeys";

type GetInvoiceDraftOptions = {
  invoiceId: string;
  options?: UseQueryOptions;
  queryFn?: any;
};

export const useGetInvoiceDraft = (data: GetInvoiceDraftOptions) =>
  useQuery({
    queryKey: invoiceQueryKeys.invoiceDraft(data.invoiceId),
    queryFn: data.queryFn ? data.queryFn : () => getInvoiceDraft(data.invoiceId).then((res: any) => res.data),
    ...data.options,
  });
